export const VERSION_INFO = { tag: '2.85.0', branch: '2.85.0', commit: '0ae4396a9d05761d7bc475192eb5b6400840ccd6', date: 'Tue Feb  3 12:02:48 UTC 2026' }
